import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { sanitizeData } from '../../core/components/FormComponent';
import { FormHandles } from '@unform/core';
import { useParams } from 'react-router-dom';
import sendMail from './Modules/SendSaleMail';
import visualizarRecibo from './Modules/VisualizarRecibo';
import { useConfiguration } from '../../../../hooks/Configuration';
import SaleStats from './Modules/SaleStats';
import ContactModule from './Modules/ContactModule';
import { FaCopy, FaMoneyCheck } from 'react-icons/fa';
import { useAuth } from '../../../../hooks/Auth';
import { FinanceReportModule } from './Modules/CheckFinance';
import refundSale from './Modules/RefundSale';
import { useToast } from '../../../../hooks/Toast';
import { useLanguage } from '../../../../hooks/Language';
import { urlWebsite } from '../../../../config';
import checkUsersTickets from './Modules/CheckUsersTicket';
import sendUsersQRCodes from './Modules/SendUsersQRCode';
 import duplicate from './Modules/Duplicate';
import { useSearch } from 'src/hooks/Search';
interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

const callback = (string, form: React.RefObject<FormHandles>) => {
  const installments = form?.current?.getFieldValue('installment') || 1;

  const discount =
    sanitizeData.currencyInput(form?.current?.getFieldValue('discount')) || 0;

  const total =
    sanitizeData.currencyInput(form?.current?.getFieldValue('total')) || 0;

  const installmentValue = parseInt(
    ((total - discount) / installments).toString(),
    10,
  );

  form?.current?.setFieldValue('installment_value', installmentValue);
};

const SaleProduct: React.FC = () => {
  const endpoint = '/sales-products';
  const title = 'Produtos atrelados a vendas';
  const {reloadSearchAll} = useSearch();
  const { user } = useAuth();
  const formSchema = {
    client_id: {
      alias: 'client_id',
      model: 'selectApi',
      name: 'client_id',
      label: 'Cliente',
      endpoint,
    },
  payer_id: {
      alias: 'payer_id',
      model: 'selectApi',
      name: 'payer_id',
      label: 'Pagador',
      endpoint,
    },
    transaction_id: {

      model: 'input',
      type: "text",
      name: 'transaction_id',
      label: 'ID de transação',

    },
    fields_text: { model: 'input', type: 'text', name: 'fields_text', label: 'Campos adicionais' },

    product_id: {
      alias: 'product_id',
      model: 'selectApi',
      name: 'product_id',
      label: 'Produto',

      endpoint,
    },

    payment_status_id: {
      model: 'selectSimple',
      name: 'payment_status_id',
      label: 'Status de pagamento',
      defaultValue: 'paid',
      options: [
        { label: 'Aguardando', value: 'waiting' },
        { label: 'Pago', value: 'paid' },
        { label: 'Cancelado', value: 'cancelled' },
        { label: 'Boleto Vencido', value: 'expired' },
        { label: 'Aguardando análise do Antifraude', value: 'verificating' },

      ]

    },


    payment_method_id: {
      model: 'selectSimple',
      name: 'payment_method_id',
      label: 'Método de pagamento',
      defaultValue: 'cortesy',
      options: [
        { label: 'Depósito', value: 'deposit' },
        { label: 'Boleto', value: 'boleto' },
        { label: 'Cartão', value: 'credit_card' },
        { label: 'Pix', value: 'pix' },
        { label: 'Cortesia', value: 'cortesy' },
      ]

    },
    seller_hash: {
      model: 'input',
      name: 'seller_hash',
      label: 'Código de afiliado',
      type: "text",

    },
    total: {
      model: 'currencyInput',
      name: 'total',
      label: 'Total',
      defaultValue: '0',
      callback,
    },
    discount: {
      model: 'currencyInput',
      name: 'discount',
      label: 'Desconto',
      defaultValue: '0',
      callback,
    },
    installment: {
      model: 'selectSimple',
      name: 'installment',
      label: 'Nº de Parcelas',
      defaultValue: '1',
      options: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
      ],
      callback,
    },
    installment_value: {
      model: 'currencyInput',
      name: 'installment_value',
      label: 'Valor da parcela',
      defaultValue: '0',
      readOnly: true,
    },




    courses: {
      model: 'JsonInput',
      endpoint: `/courses`,
      name: 'courses',
      label: 'Cursos',
    },
  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const { projectHash, eventHash } = useConfiguration();

  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'Protocolo', show: false },
    project_id: {
      ref: 'project_id',
      column: 'project_id',
      label: 'Projeto',

    },
    event_id: {
      ref: 'event_id',
      column: 'event_id',
      label: 'Evento',

    },
    ticket_hash: {
      ref: 'ticket_hash',
      column: 'ticket_hash',
      label: 'Ticket Hash',
      show: false,
    },
    phone: {
      ref: 'phone',
      column: 'phone',
      label: 'Telefone',
      show: false,
    },
    seller_hash: {
      ref: 'seller_hash',
      column: 'seller_hash',
      label: 'Cod. Afiliado',

    },
    sale_hash: {
      ref: 'sale_hash',
      column: 'sale_hash',
      label: 'Hash',
      show: false,
    },
    installment_value: {
      ref: 'installment_value',
      column: 'installment_value',
      label: 'Valor da Parcela',
      mask: 'currency',
      show: false,
    },
    cortesy_hash_id: {
      ref: 'cortesy_hash_id',
      column: 'cortesy_hash_id',
      label: 'Hash da cortesia',
 
      show: false,
    },
    payment_status: {
      ref: 'payment_status_id',
      column: 'payment_status_id',
      label: 'Status',
    },
    payment_method: {
      ref: 'payment_method_id',
      column: 'payment_method_id',

      label: 'Forma de Pagamento',
    },
    installment: {
      ref: 'installment',
      column: 'installment',
      label: 'Nº de Parcelas',
    },
    total: { ref: 'total', column: 'total', label: '(=)Total (Bruto)', mask: 'currency' },
    fees: { ref: 'fees', column: 'fees', label: '(-)Taxa Cliente', mask: 'currency' },
    tax: { ref: 'tax', column: 'tax', label: '(-) Taxa Empresa', mask: 'currency' },
    transaction_tax: { ref: 'transaction_tax', column: 'transaction_tax', label: '(-) Taxa de transação', mask: 'currency' },
    adminstration_tax: { ref: 'adminstration_tax', column: 'adminstration_tax', label: '(-) Taxa adm.', mask: 'currency' },
    net_total: { ref: 'net_total', column: 'net_total', label: '(=)Total (Líquido)', mask: 'currency' },

    product: {
      ref: 'product_id',
      column: 'product_id_response',
      includeColumn: 'title',
      label: 'Produto',
    },
    client_id: {
      ref: 'client_id',
      column: 'client_id_response',
      includeColumn: 'name',
      label: 'Cliente',
    },
    payer_id: {
      ref: 'payer_id',
      column: 'payer_id_response',
      includeColumn: 'name',
      label: 'Comprador',
    },
    fields_text: {
      ref: 'fields_text',
      column: 'fields_text',
      label: 'Campos adicionais',

    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };


  const formSchemaPayment = {
    tax: {
      model: 'currencyInput',
      name: 'tax',
      label: 'Taxa Fixa',
      defaultValue: '0',
      callback,
    },
    fees: {
      model: 'currencyInput',
      name: 'fees',
      label: 'Taxas do cliente',
      defaultValue: '0',
      callback,
    },
    administration_tax: {
      model: 'currencyInput',
      name: 'administration_tax',
      label: 'Taxa de transação',
      defaultValue: '0',
      callback,
    },
    transaction_tax: {
      model: 'currencyInput',
      name: 'transaction_tax',
      label: 'Taxa de transação',
      defaultValue: '0',
      callback,
    },
    net_total: {
      model: 'currencyInput',
      name: 'net_total',
      label: 'Total Líquido',
      defaultValue: '0',
      callback,
    },
    total: {
      model: 'currencyInput',
      name: 'total',
      label: 'Total',
      defaultValue: '0',
      callback,
    },
    discount: {
      model: 'currencyInput',
      name: 'discount',
      label: 'Desconto',
      defaultValue: '0',
      callback,
    },
    installment: {
      model: 'selectSimple',
      name: 'installment',
      label: 'Nº de Parcelas',
      defaultValue: '1',
      options: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
      ],
      callback,
    },
    installment_value: {
      model: 'currencyInput',
      name: 'installment_value',
      label: 'Valor da parcela',
      defaultValue: '0',
      readOnly: true,
    },




    courses: {
      model: 'JsonInput',
      endpoint: `/courses`,
      name: 'courses',
      label: 'Cursos',
    },
  };

  const { addToast } = useToast();
  const { translate } = useLanguage();

  const copyToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    addToast({ type: 'success', 'title': translate('Link do ingresso copiado para o Clipboard') })

  }

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      () =>
        checkUsersTickets(),
      () =>
        sendUsersQRCodes(),
      () =>
        <FinanceReportModule />,
    ],
    bodyModules: user.email === 'guilherme@encontrodigital.com.br' ?
      [
        (lineData: Record<string, any>) =>
          lineModules.updateUnique({
            lineData,
            title,
            formSchema,
            validationSchema: {},
            endpoint,
          }),
        (lineData: Record<string, any>) =>
          lineModules.updateUnique({
            lineData,
            title,
            formSchema: formSchemaPayment,
            validationSchema: {},
            endpoint,
            Icon: FaMoneyCheck
          }),


        (lineData: Record<string, any>) =>
          lineModules.delete({
            lineData,
            title,
            formSchema,
            validationSchema: formValidation,
            endpoint,
          }),
        (lineData: Record<string, any>) =>
          sendMail({
            lineData,

          }),
        (lineData: Record<string, any>) => lineData?.payment_status_id === 'paid' ? <button title='Transferir Ingresso' onClick={() => copyToClipboard(`${urlWebsite}/app/${lineData?.project_id}/validar-ingresso/${lineData?.ticket_hash}`)} className='greenButton2 buttonColored lineIcon' ><FaCopy /></button> : <></>
,
             (lineData: Record<string, any>) =>
          duplicate({
            lineData, reload: reloadSearchAll 

          })

      ] : [
        (lineData: Record<string, any>) =>
          lineModules.updateUnique({
            lineData,
            title,
            formSchema,
            validationSchema: {},
            endpoint,
          }),
        (lineData: Record<string, any>) =>
          lineModules.delete({
            lineData,
            title,
            formSchema,
            validationSchema: formValidation,
            endpoint,
          }),
        (lineData: Record<string, any>) =>
          sendMail({
            lineData,

          }),
        (lineData: Record<string, any>) => lineData?.payment_status_id === 'paid' ? <button title='Transferir Ingresso' onClick={() => copyToClipboard(`${urlWebsite}/app/${lineData?.project_id}/validar-ingresso/${lineData?.ticket_hash}`)} className='greenButton2 buttonColored lineIcon' ><FaCopy /></button> : <></>
,
             (lineData: Record<string, any>) =>
          duplicate({
            lineData, reload: reloadSearchAll 

          })
      ],
  };

  return (
    <Container>
      <SaleStats />
      <SearchComponent {...config} />
    </Container>
  );
};

export default SaleProduct;
